let counter = 0

export function generateUniqueId(): string {
  return `collector:${Math.random().toString().substr(2, 10)}-${Date.now()}-${++counter}`
}
